import { Controller } from "@hotwired/stimulus"

// Opens and closes the sidebar on phones and tablets. On wide screens the
// sidebar is always shown and this does nothing visible.
export default class extends Controller {
  static targets = ["panel", "backdrop", "button"]

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    this.panelTarget.classList.replace("hidden", "flex")
    this.backdropTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.panelTarget.querySelector("a, button")?.focus()
  }

  close() {
    if (this.panelTarget.classList.contains("hidden")) return

    this.panelTarget.classList.replace("flex", "hidden")
    this.backdropTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.buttonTarget.focus()
  }
}
